import {KeyedAction, Action, StoreAPI} from '../Store';
import {RootState} from '../State';
import {Injector} from '../../common/Injector';
import {API} from '../../model/API';
import {MiscData} from '../../model/api/Misc';

export type OrganizationState = Readonly<{
    logo?: string;
    loginLogo?: string;
    activeThemeId?: string;
    themes?: [];
}>;

export const OrganizationInitialState: OrganizationState = {

};

export class SetOrganization extends KeyedAction<RootState, 'organization'> {
    public type: string = '@@ORGANIZATION/SET_ORGANIZATION';

    constructor(private readonly orgSettings: OrganizationState) {
        super('organization');
    }

    public reduce(state: OrganizationState): OrganizationState {
        return this.orgSettings;
    }
}

export class RefreshOrganization extends Action<RootState> {
    public type: string = '@@ORGANIZATION/REFRESH';

    public async call(store: StoreAPI<RootState>): Promise<void> {
        console.log('Refresh organization settings.');
        const api: API = Injector.get('API') as API;
        const settings = await api.get(MiscData.ORG_SETTINGS);
        await store.dispatch(new SetOrganization(settings || {}));
    }
}
